import "./ServicesPartner.css";

import React from 'react'
import ServiceT from "./../../../Assets/ServicesPartner.png";
import YearE from "./../../../Assets/Year_Experience.webp";
import dooted from "./../../../Assets/dotted.png"
import girl from "./../../../Assets/girl.webp"
import laptop from "./../../../Assets/laptop.webp"


function ServicesPartner() {
  return (
    <div className="SR-layout1">
      <p className="sr-content1">GET TO KNOW US</p>
      <div className="SR-layout2">
        <div className="SR-layout3">
          <img src={dooted} alt="" className="dooted_style"/>
          <img src={girl} alt="A 360 SynergyTech developer working on a laptop" className="girl_style"/>
          <img src={laptop} alt="" className="laptop_style" width="200" height="200" loading="lazy"/>
          <div className="yearexp_style"><strong>10+</strong><span>Years of Experience</span></div>
        </div>
        <div className="SR-layout4">
          <div className="SR-layout42">
            <h2 className="sr-content2">
              <span>YOUR BEST DIGITAL SOLUTION </span>
              <span className="sr-content3">SERVICE </span>
              <span>PARTNER</span>
            </h2>
          </div>
          <div className="SR-layout43">
            <p className="sr-content4">
              We design and build custom software, AI, cloud and data solutions that fit the way your business works.
            </p>
          </div>
          <div className="SR-layout44">
            <div className="sr-layout-row">
              <div className="sr-layoutW">
                <img src={ServiceT} alt="" className="srt-content" width="16" height="16" loading="lazy" />
                <p className="sr-contentW">Custom software development</p>
              </div>
              <div className="sr-layoutW">
                <img src={ServiceT} alt="" className="srt-content" width="16" height="16" loading="lazy" />
                <p className="sr-contentW">AI and machine learning</p>
              </div>
            </div>

            <div className="sr-layout-row">
              <div className="sr-layoutW">
                <img src={ServiceT} alt="" className="srt-content" width="16" height="16" loading="lazy" />
                <p className="sr-contentW">Cloud and data engineering</p>
              </div>
              <div className="sr-layoutW">
                <img src={ServiceT} alt="" className="srt-content" width="16" height="16" loading="lazy" />
                <p className="sr-contentW">CRM platform implementation</p>
              </div>
            </div>
            <div className="sr-layout-row">
              <div className="sr-layoutW">
                <img src={ServiceT} alt="" className="srt-content" width="16" height="16" loading="lazy" />
                <p className="sr-contentW">Digital commerce solutions</p>
              </div>
              <div className="sr-layoutW">
                <img src={ServiceT} alt="" className="srt-content" width="16" height="16" loading="lazy" />
                <p className="sr-contentW">RPA and system integration</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServicesPartner
